export enum EventsListItemAction {
  deleteEvent = 'deleteEvent',
  duplicateEvent = 'duplicateEvent',
  editEvent = 'editEvent',
  ceaReport = 'ceaReport',
  editPublishedEvent = 'editPublishedEvent',
  manageEvent = 'manageEvent',
  showEventLinks = 'showEventLinks',
  exportParticipants = 'exportParticipants',
  generateQrCodes = 'generateQrCodes',
  exportSignatures = 'exportSignatures',
  sendInvitation = 'sendInvitation',
  unpublishEvent = 'unpublishEvent',
  syncVeevaParticipants = 'syncVeevaParticipants',
}
